export default __webpack_public_path__ + "static/card_2-4cf8f3a6d2beffe5d508970b1ed95e4b.png";